export default [
    {
        "value" : "PesquisaBasica",
        "text" : "Pesquisa básica",
        "sigla" : "PB"
    },
    {
        "value" : "PesquisaAplicada",
        "text" : "Pesquisa aplicada",
        "sigla" : "PA"
    },
    {
        "value" : "DesenvolvimentoExperimental",
        "text" : "Desenvolvimento experimental",
        "sigla" : "DE"
    },
    {
        "value" : "CabecaDeSerie",
        "text" : "Cabeça de série",
        "sigla" : "CS"
    },
    {
        "value" : "LotePioneiro",
        "text" : "Lote pioneiro",
        "sigla" : "LP"
    },
    {
        "value" : "InsercaoNoMercado",
        "text" : "Inserção no mercado",
        "sigla" : "IM"
    }
];